<pdf-viewer [config]="config" [isBlob]="true"></pdf-viewer>
<div class="_ptfloating-action-bar">
  <div class="_ptfloating-action-main">
    <div class="ai_cat">
      <div class="ai_cat-category">
        {{ 'ai_selected_cat' | translate | async}} :
      </div>
      <div class="ai_cat-category_name">
        <b>{{config.splName}}</b>
      </div>
    </div>
    @if (config.isRefer) {
      <button (click)="referralRequest()" class="primary-btn"> Referral Request <i class="fa fa-chevron-right"></i></button>
    }
    @if (!config.isRefer) {
      <button (click)="bookAppointment()" class="primary-btn"> Book Appointment <i class="fa fa-chevron-right"></i></button>
    }
  </div>
